import type { CmsData } from '../../../interfaces/webapp_json';

// Client-side only store — only mutated inside useEffect (never on the server).
let content: CmsData | null = null;
const listeners = new Set<() => void>();

export const previewContentStore = {
  get: (): CmsData | null => content,
  set: (c: CmsData | null) => {
    content = c;
    listeners.forEach((l) => l());
  },
  subscribe: (listener: () => void) => {
    listeners.add(listener);
    return () => {
      listeners.delete(listener);
    };
  },
};
